(function () {
  var mobile = window.matchMedia("(max-width: 749px)");

  function bindHeader() {
    if (!mobile.matches) return;
    var root = document.querySelector("[data-lunastra-header]");
    if (!root || root.dataset.mobileMenuReady === "true") return;
    var toggle = root.querySelector("[data-ls4-menu-toggle]");
    var nav = root.querySelector(".nav");
    if (!toggle || !nav) return;

    root.dataset.mobileMenuReady = "true";
    root.dataset.lsReady = "true";

    function setOpen(open) {
      root.dataset.menuOpen = String(open);
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      document.documentElement.classList.toggle("ls-drawer-open", open);
    }

    nav.addEventListener("click", function (event) {
      if (event.target.closest("a")) setOpen(false);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") setOpen(false);
    });
  }

  function revealScene() {
    if (!mobile.matches) return false;
    var scene = document.querySelector("[data-ls-cinematic-scene]");
    if (!scene) return false;
    scene.dataset.lsPlayed = "true";
    scene.classList.add("is-ready");
    return true;
  }

  bindHeader();
  if (!revealScene()) {
    var observer = new MutationObserver(function () {
      if (revealScene()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 10000);
  }
})();
